import type { SpecRow } from '../types/products';

interface SpecTableProps {
  rows: SpecRow[];
  /** Show the middle "Method" column (used for ASTM specs). */
  showMethod?: boolean;
  title?: string;
}

export default function SpecTable({ rows, showMethod = true, title }: SpecTableProps) {
  const withMethod = showMethod && rows.some((r) => r.method);
  return (
    <div className="overflow-hidden rounded-lg border border-ink/12">
      {title && (
        <div className="bg-primary-deep px-5 py-3 text-sm font-semibold uppercase tracking-wide text-white">
          {title}
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-left text-sm">
          <thead>
            <tr className="bg-muted text-xs uppercase tracking-wide text-ink-soft">
              <th className="px-5 py-3 font-semibold">Property</th>
              {withMethod && <th className="px-5 py-3 font-semibold">Method</th>}
              <th className="px-5 py-3 font-semibold">Specification</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.property} className={i % 2 ? 'bg-background/60' : 'bg-surface'}>
                <td className="px-5 py-3 font-medium text-text-primary">{row.property}</td>
                {withMethod && (
                  <td className="px-5 py-3 text-text-secondary">{row.method ?? '—'}</td>
                )}
                <td className="px-5 py-3 text-text-secondary">{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
